/**
 * audit（02 5.3.22）の型 AuditLog と一覧のクエリ（API-AUDT-01）。
 * 期間（occurred_at_from・occurred_at_to）は必須・最大 92 日（超えたら service が 422 LIST_001）。
 */
import { z } from 'zod';
import { AUDIT_ACTION_TYPE_VALUES } from '../enums/audit-action-type';
import { TARGET_ENTITY_TYPE_VALUES } from '../enums/target-entity-type';
import { zCode, zDateTime, zEnum, zSystemCode } from './common.schema';
import { DEFAULT_PER_PAGE, MAX_PER_PAGE } from './list-query.schema';

/** 期間の上限（02 5.3.22・03 FE-MSG-V-013） */
export const AUDIT_LOG_PERIOD_MAX_DAYS = 92;

export const ChangedFieldSchema = z.object({ field: z.string(), before: z.unknown(), after: z.unknown() });

export const AuditLogSchema = z.object({
  audit_log_code: z.string(),
  occurred_at: z.string(),
  actor_user_code: z.string().nullable(),
  actor_user_name: z.string().nullable(),
  attempted_email: z.string().nullable(),
  audit_action_type: z.enum(AUDIT_ACTION_TYPE_VALUES),
  audit_action_name: z.string(),
  target_entity_type: z.string(),
  target_entity_type_name: z.string(),
  target_entity_key: z.string().nullable(),
  target_entity_name: z.string().nullable(),
  before_map: z.record(z.unknown()).nullable(),
  after_map: z.record(z.unknown()).nullable(),
  changed_fields: z.array(ChangedFieldSchema),
  ip_address: z.string().nullable(),
  trace_id: z.string(),
});

export const AUDIT_LOG_LIST_SORT_VALUES = ['occurred_at'] as const;

/** API-AUDT-01（2.3 のページング・並べ替え＋期間必須） */
export const AuditLogListQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  per_page: z.coerce.number().int().min(1).max(MAX_PER_PAGE).default(DEFAULT_PER_PAGE),
  sort: z.enum(['occurred_at', '-occurred_at'], { message: 'MSG-V-020' }).default('-occurred_at'),
  q: z.string().trim().min(1).max(100).optional(),
  occurred_at_from: zDateTime,
  occurred_at_to: zDateTime,
  actor_user_code: zSystemCode.optional(),
  target_entity_type: zEnum(TARGET_ENTITY_TYPE_VALUES).optional(),
  target_entity_key: zCode.optional(),
  audit_action_type: zEnum(AUDIT_ACTION_TYPE_VALUES).optional(),
});

export type ChangedField = z.infer<typeof ChangedFieldSchema>;
export type AuditLog = z.infer<typeof AuditLogSchema>;
export type AuditLogListQuery = z.infer<typeof AuditLogListQuerySchema>;
